/**
 * `http://`もしくは`https://`から始まるURLのみを受け付ける
 * （これら以外のプロトコルを持ったURLスキームを許可しない）
 *
 * @param url
 * @returns
 */
export const validateSafetyUrl = (url: string) => {
  try {
    const parsed = new URL(url);

    return ['https:', 'http:'].includes(parsed.protocol);
  } catch {
    return false;
  }
};
